import { createFileRoute } from "@tanstack/react-router"
import { StoreInfoReport } from "@/features/reports/components/StoreInfoReport"
import {
  applyStoreInfoDefaults,
  storeInfoQuery,
  StoreInfoSearchParams,
} from "@/features/reports/core/hooks/useStoreInfoReport"

export const Route = createFileRoute("/(authenticated)/reports/store-info")({
  validateSearch: StoreInfoSearchParams,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps: search }) => {
    void context.queryClient.ensureQueryData(storeInfoQuery(applyStoreInfoDefaults(search)))
  },
  component: StoreInfoReport,
})
